import(/* webpackMode: "eager" */ "/workspace/web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/web/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["BugSnagInit"] */ "/workspace/web/src/app/bugsnag.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/web/src/app/gtmPageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopProgressBar"] */ "/workspace/web/src/shared/components/TopProgressBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebPageViewLogger"] */ "/workspace/web/src/shared/components/WebPageViewLogger.tsx");
